import styled from 'styled-components'
import theme from '../../styles/theme'
export const AccordionWrapper = styled.div`
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  text-size-adjust: 100%;
  color: ${theme.color.black};
`
export const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  box-shadow: inset 0px -3px 0px ${theme.color.boxShadow};
  padding-top: 15px;
  padding-bottom: 15px;
`

export const AccordionTitle = styled.h2`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 0px;
  color: ${theme.color.black};
  display: block;
  margin: 0px;
`

export const ToggleButton = styled.button`
  text-decoration: underline;
  color: ${theme.color.btnText};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  background: transparent;
  appearance: none;
  cursor: pointer;
  align-items: center;
  border: none;
  padding: 0;
`

export const AccordionContainer = styled.div`
  font-size: 1rem;
  line-height: 1.5;
  display: block;
  border: 1px solid gray;
  font-family: inherit;
  color: ${theme.color.black};
  padding: 0;
`

export const AccordionButton = styled.button`
  width: 100%;
  background-color: ${theme.color.bgShade};
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding: 1rem 1rem 1rem 1rem;
  color: ${theme.color.btnText};
  text-decoration: underline;
  font-weight: bold;
  position: relative;
  box-sizing: border-box;
  border: none;
  text-align: left;
  font-family: inherit;

  &:focus {
    outline: 3px solid #9263de;
    outline-offset: 2px;
    text-decoration: none !important;
    color: ${theme.color.black} !important;
    z-index: 10;
  }
`

export const AccordionToggleIcon = styled.img`
  top: 50%;
  width: 1rem;
  right: 1rem;
  height: 1rem;
  transition: transform 0.25s ease-in;
  transform: ${({ expanded }) => (expanded ? 'rotate(180deg)' : 'none')};
`

export const AccordionDetails = styled.div`
  display: block;
  height: auto;
  font-size: 1rem;
  line-height: 1.5;
  overflow: scroll;
  border-top: 1px solid gray;
  max-height: ${(props) => (props['aria-hidden'] ? '0' : '19rem')};
  transition: max-height 0.25s ease-in-out;
`

export const AccordionText = styled.span`
  padding: 1rem;
  display: flex;
  & > div {
    & > ul {
      margin-bottom: 0;
    }
  }
`
